export default "__VITE_ASSET__tvvxKpUr__"